module.exports = __webpack_public_path__ + "static/media/patch.d094e5c3.webp";